(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trDashboardTopStats', trDashboardTopStats);

  function trDashboardTopStats() {
    const directive = {
      restrict: 'E',
      controller: 'DashboardTopStatsController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/dashboard/dashboard-top-stats.view.html'
    };
    return directive;
  }
})();
